import { render, staticRenderFns } from "./TreatList.vue?vue&type=template&id=52e196a5"
import script from "./TreatList.vue?vue&type=script&lang=js"
export * from "./TreatList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports